import { FC } from 'react';

import { Box } from '@mui/material';
import { styles } from './styles';

export const OutOfStockLabel: FC = () => {
  return <Box sx={styles.container}>Out of stock</Box>;
};
